import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Trans, withTranslation,useTranslation } from "react-i18next";

const initialValue = {
  alert: false,
  head: "",
  message: "",
  success: true,
  action: null,
};
const AlertBox = ({ options,splFunction }) => {
  const { t } = useTranslation();
  const [alertObj, setAlertObj] = useState(initialValue);

  useEffect(() => {
    setAlertObj((prev) => ({
      ...prev,
      alert: options.alert,
      head: options.head,
      message: options.message,
      success: options.success,
      action: options.action,
    }));
  }, [options]);

  const closeModal = () => {
    if(splFunction){
      splFunction()
    }
    setAlertObj(initialValue);
  };

  const actionButton=()=>{
    alertObj.action()
    setAlertObj(initialValue)
  }

  return (
    <Modal isOpen={alertObj.alert} centered={true}>
      <ModalHeader>
        <h4
          className={`alert-box-head ${
            alertObj.success ? "success-head" : "failure-head"
          }`}
        >
          {alertObj.head != "" ? alertObj.head : "Successfully completed!"}
        </h4>
      </ModalHeader>
      <ModalBody>
        <p className="alert-box-body">
          {alertObj.message != ""
            ? alertObj.message
            : "The given task is successfully completed. Press Okay to close this"}
        </p>
      </ModalBody>
      <ModalFooter>
        {alertObj.action && (
          <button className="alert-box-button alert-box-success-btn" onClick={actionButton}>
            {t('Yes')}
          </button>
        )}
        <button className={`alert-box-button ${alertObj.action?"alert-box-failure-btn":"alert-box-success-btn"}`}onClick={closeModal}>
          {alertObj.action ? t('Cancel') : t('Yes')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AlertBox;
